import { useParams } from 'react-router-dom';
import CustomLayout from '../components/custom-layout';
import Starfield from '../backgrounds/starfield';
import { kebabCase } from '../scripts/string-manipulators';
import { Outlet } from 'react-router-dom';
import { ProjectType } from '../types/projects';
import Section from '../components/portfolio/section';
import Article from '../components/portfolio/article';
import Content from '../components/portfolio/content';
import projectJSON from '../data/project.json';

const Projects = () => {
  const { id } = useParams();
  const { projectData } = projectJSON;

  return (
    <CustomLayout
      background={<Starfield />}
    >
      <Section
        id={id}
        title="Project"
        collective="Projects"
      >
        {!id && (
          <>
            {projectData.map((project: ProjectType) => (
              <Article
                key={kebabCase(project.projectName)}
                articleName="Project"
                title={project.projectName}
                type={project.type}
                url={project.projectUrl}
              >
                <Content
                  articleName={project.projectName}
                  description={project.description}
                  exampleAlt={project.exampleAlt}
                  exampleUrl={project.exampleUrl}
                  intro={project.intro}
                  knowledge={project.knowledge}
                  logo={project.logo}
                />
              </Article>
            ))}
          </>
        )}

        <Outlet />
      </Section>
    </CustomLayout>
  );
};

export default Projects;
